/**
 * 웹에서의 point는 pixel의 4/3배이며, 이유는 모니터가 종이보다 4/3배 멀리서 보기 때문이라고 합니다.
 * @see https://www.theteams.kr/teams/371/post/64214
 */
function ptToPx(point) {
  return (point * 4) / 3;
}

export default ptToPx;
